import { render, staticRenderFns } from "./TopCompanies.vue?vue&type=template&id=307eb6ae&scoped=true"
import script from "./TopCompanies.vue?vue&type=script&lang=js"
export * from "./TopCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307eb6ae",
  null
  
)

export default component.exports